import { writable, derived } from 'svelte/store';

/**
 * Available routes in the application
 */
export const routes = {
  home: '/',
  catalog: '/catalog',
  about: '/about',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms'
};

/**
 * Current route store
 */
function createRouteStore() {
  const { subscribe, set } = writable('home');

  // Parse initial route from URL
  function parseRoute() {
    const path = window.location.pathname;
    const route = Object.entries(routes).find(([, value]) => value === path);
    return route ? route[0] : 'home';
  }

  // Initialize with current URL
  if (typeof window !== 'undefined') {
    set(parseRoute());

    // Listen for popstate (browser back/forward)
    window.addEventListener('popstate', () => {
      set(parseRoute());
    });
  }

  return {
    subscribe,
    set
  };
}

export const currentRoute = createRouteStore();

/**
 * Navigate to a route
 * @param {string} route - Route name (key from routes object)
 */
export function navigate(route) {
  if (routes[route]) {
    const path = routes[route];
    window.history.pushState({}, '', path);
    currentRoute.set(route);
    
    // Scroll to top on navigation
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    console.warn(`Route "${route}" not found`);
  }
}

/**
 * Check if a route is active
 * @param {string} route - Route name to check
 * @returns {import('svelte/store').Readable<boolean>}
 */
export function isActive(route) {
  return derived(currentRoute, ($currentRoute) => $currentRoute === route);
}
